import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Tooltip } from 'ui/tooltip';
import { HTTPS_DISABLED_TOOLTIP, LEGACY_PATH_DISABLED_TOOLTIP } from '../constants';
import { AppSiteAssociations } from '../types';

type Props = {
  row: AppSiteAssociations;
  onEdit: (row: any) => void;
  onEnable: (row: any) => void;
  isDisabled: boolean;
};

export const PathsTableOverflowMenu = ({ row, onEdit, onEnable, isDisabled }: Props) => {
  const isEditOptionDisabled = isDisabled || !row.appDomain;
  const tooltipContent = !row.appDomain ? LEGACY_PATH_DISABLED_TOOLTIP : HTTPS_DISABLED_TOOLTIP;

  return (
    <OverflowMenu
      id="paths-table-overflow-menu"
      options={[
        {
          as: AllowedActionMenuElements.Button,
          content: (
            <Tooltip tooltipContent={tooltipContent} isEnabled={isEditOptionDisabled}>
              Edit
            </Tooltip>
          ),
          id: 'edit',
          isDisabled: isEditOptionDisabled,
          onClick: () => onEdit(row),
        },
        {
          as: AllowedActionMenuElements.Button,
          content: <>{row.enabledForProject ? 'Disable domain' : 'Enable domain'}</>,
          id: 'enable',
          onClick: () => onEnable(row),
        },
      ]}
    />
  );
};
